import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ec95ef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "review-modal items-in-column" }
const _hoisted_2 = {
  key: 0,
  class: "l-font-size"
}
const _hoisted_3 = { class: "center" }

import { ref, Ref } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { ErrorsType } from '@/types';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { vMaska } from 'maska';
import { sendReview } from '@/api/common';

type FormDataType = {
  comment: string | undefined;
  name?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FullReviewModal',
  props: {
    showModal: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const formData: Ref<FormDataType> = ref({
  phone: undefined,
  email: undefined,
  comment: undefined,
  name: undefined,
});

const clearFormData = () => {
  v$.value.$reset();
  for (const [key] of Object.entries(formData)) {
    formData.value[key as keyof FormDataType] = undefined;
  }
};
const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  comment: { required },
  email: { required, email },
  phone: { required },
  name: { required },
};

const v$ = useVuelidate<FormDataType>(rules, formData);
const errors: Ref<ErrorsType> = ref({});
const showSuccessMessage: Ref<boolean> = ref(false);
const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const loading = ref(false);
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value?.$touch();
    validationErrorsHandler();

    return;
  }

  loading.value = true;
  const preparedFormData = {
    phone: formData.value.phone?.replace(/[^\d]/g, ''),
    email: formData.value.email,
    comment: formData.value.comment,
    name: formData.value.name,
  };

  try {
    const res = await sendReview(preparedFormData);

    if (res) {
      clearFormData();
      showSuccessMessage.value = true;
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};

const closeModal = () => {
  clearFormData();
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.showModal,
    title: "Отзыв / Предложение",
    onClose: closeModal
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (showSuccessMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Отзыв успешно отправлен!"))
          : (_openBlock(), _createBlock(_component_base_form, {
              key: 1,
              class: "review-modal__full-form review-modal__form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  error: errors.value.name,
                  invalid: !!errors.value.name,
                  height: "36",
                  label: "Имя",
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('name'))),
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.name)),
                  onInput: _unref(v$).name?.$touch
                }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
                _withDirectives(_createVNode(_component_base_input, {
                  modelValue: formData.value.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phone) = $event)),
                  error: errors.value.phone,
                  invalid: !!errors.value.phone,
                  "data-maska": "(###)###-##-##",
                  height: "36",
                  label: "Телефон",
                  placeholder: "(999)000-99-99",
                  prefix: "+7 ",
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('phone'))),
                  onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.phone)),
                  onInput: _unref(v$).phone?.$touch
                }, null, 8, ["modelValue", "error", "invalid", "onInput"]), [
                  [_unref(vMaska)]
                ]),
                _createVNode(_component_base_input, {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.email) = $event)),
                  error: errors.value.email,
                  invalid: !!errors.value.email,
                  height: "36",
                  label: "E-mail",
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (validationErrorsHandlerByKey('email'))),
                  onFocus: _cache[8] || (_cache[8] = ($event: any) => (delete errors.value.email)),
                  onInput: _unref(v$).email?.$touch
                }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
                _createVNode(_component_base_textarea, {
                  modelValue: formData.value.comment,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.comment) = $event)),
                  error: errors.value.comment,
                  invalid: !!errors.value.comment,
                  height: "85",
                  label: "Комментарий",
                  textarea: "",
                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (validationErrorsHandlerByKey('comment'))),
                  onFocus: _cache[11] || (_cache[11] = ($event: any) => (delete errors.value.comment)),
                  onInput: _unref(v$).comment?.$touch
                }, null, 8, ["modelValue", "error", "invalid", "onInput"])
              ]),
              _: 1
            })),
        _createElementVNode("div", _hoisted_3, [
          (showSuccessMessage.value)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                height: "40",
                text: "Закрыть",
                width: "150",
                onClick: closeModal
              }))
            : (_openBlock(), _createBlock(_component_base_button, {
                key: 1,
                loading: loading.value,
                height: "40",
                text: "Отправить",
                width: "150",
                onClick: formSubmit
              }, null, 8, ["loading"]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["show-modal"]))
}
}

})